// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__bWAf8","btn":"styles_btn__Lclaj","count":"styles_count__k7hRI"};